import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { selectUnidadeSelecionada } from '../../../../../features/usuario-logado/usuarioLogadoSlice';
import MultiSelectFormInput from '../../../../common/components/forms/MultiSelectFormInput';
import { ProformaPackingListSaidaFiltroOption } from '../proformaPackingListSaida.helpers';

type Props = {
  name: string;
  label: string;
  fetchOptions: (token: string, unidadeId: number) => Promise<ProformaPackingListSaidaFiltroOption[]>;
};

function MultiSelectFiltroOptions({ name, label, fetchOptions }: Props) {
  const { keycloak } = useKeycloak();
  const { token } = keycloak;

  const selectedUnit = useSelector(selectUnidadeSelecionada);

  const [options, setOptions] = useState<ProformaPackingListSaidaFiltroOption[]>([]);

  useEffect(() => {
    if (!token || !selectedUnit) {
      setOptions([]);
      return undefined;
    }

    let ativo = true;

    fetchOptions(token, selectedUnit)
      .then((data) => {
        if (ativo) {
          setOptions(data);
        }
      })
      .catch(() => {
        if (ativo) {
          setOptions([]);
        }
      });

    return () => {
      ativo = false;
    };
  }, [token, selectedUnit, fetchOptions]);

  return <MultiSelectFormInput name={name} options={options} label={label} />;
}

export default MultiSelectFiltroOptions;
